var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CheckCircleSvg from './check-circle.icon.svg';
export const CheckCircleIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: CheckCircleSvg }));
_react_refresh_temp_1 = CheckCircleIcon;
$RefreshReg$(_react_refresh_temp_1, "CheckCircleIcon");
